import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaCheckCircle,
} from "react-icons/fa";
import promoweb from "../../static/media/services/promoweb.webp";

const blue = "#0A3D91";

const MotionBox = motion(Box);

const webPoints = [
  "Sitios web profesionales y administrables",
  "Desarrollo a medida con tecnologías modernas",
  "Diseño rápido, atractivo y orientado a conversión",
  "Experiencia optimizada para móviles y escritorio",
];

const PromoWeb = () => {
  const waGeneral =
    "https://wa.me/593963075045?text=Hola%2C%20necesito%20informaci%C3%B3n%20sobre%20sus%20servicios%20tecnol%C3%B3gicos";
  const waWeb =
    "https://wa.me/593963075045?text=Hola%2C%20quiero%20informaci%C3%B3n%20para%20crear%20mi%20p%C3%A1gina%20web";

  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, #ffffff 0%, #f7faff 50%, #ffffff 100%)",
        py: { xs: 6, md: 9 },
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: "1180px",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#071126",
            color: "#fff",
            borderRadius: { xs: "24px", md: "30px" },
            overflow: "hidden",
            position: "relative",
            boxShadow: "0 30px 80px rgba(7,17,38,0.22)",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(135deg, rgba(10,61,145,0.97) 0%, rgba(5,12,28,0.98) 50%, rgba(13,110,253,0.92) 100%)",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(900px 420px at 12% 8%, rgba(255,255,255,0.10), rgba(255,255,255,0) 60%)",
            }}
          />

          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              p: { xs: 3, sm: 4, md: 5 },
            }}
          >
            <Typography
              component="h3"
              sx={{
                width: "100%",
                fontSize: { xs: "1.65rem", sm: "2rem", md: "2.5rem" },
                lineHeight: { xs: 1.14, md: 1.08 },
                fontWeight: 750,
                letterSpacing: -0.4,
                mb: { xs: 2.5, md: 3 },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Creamos páginas web con enfoque en rendimiento, imagen y conversión
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) minmax(0, 1fr)" },
                alignItems: "center",
                gap: { xs: 3, md: 4.5 },
                mb: { xs: 3.2, md: 4 },
              }}
            >
              <MotionBox
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.55, ease: "easeOut" }}
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    maxWidth: { xs: "100%", md: "480px" },
                    borderRadius: { xs: "22px", md: "28px" },
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.12)",
                    boxShadow: "0 28px 60px rgba(0,0,0,0.30)",
                    mx: "auto",
                  }}
                >
                  <Box
                    component="img"
                    src={promoweb}
                    alt="Desarrollo de páginas web profesionales"
                    loading="lazy"
                    sx={{
                      width: "100%",
                      display: "block",
                      objectFit: "cover",
                      aspectRatio: { xs: "4 / 3", md: "4 / 3" },
                    }}
                  />

                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0.04) 45%, rgba(0,0,0,0) 100%)",
                      pointerEvents: "none",
                    }}
                  />
                </Box>
              </MotionBox>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.92)",
                    lineHeight: 1.8,
                    fontSize: { xs: "1rem", md: "1.07rem" },
                    mb: 3,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Desarrollamos sitios web modernos, rápidos y visualmente sólidos
                  para negocios que necesitan transmitir confianza, destacar su
                  marca y convertir visitas en oportunidades reales de venta.
                </Typography>

                <Stack spacing={1.4}>
                  {webPoints.map((point) => (
                    <Box
                      key={point}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1.2,
                        color: "rgba(255,255,255,0.98)",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          color: "#b9d9ff",
                          fontSize: "0.98rem",
                          mt: "0.28rem",
                          flexShrink: 0,
                        }}
                      >
                        <FaCheckCircle />
                      </Box>
                      <Typography
                        sx={{
                          fontSize: { xs: "0.98rem", md: "1rem" },
                          fontWeight: 500,
                          lineHeight: 1.65,
                        }}
                      >
                        {point}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Box>
            </Box>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              sx={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                component="a"
                href={waWeb}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                sx={{
                  backgroundColor: "#fff",
                  color: blue,
                  px: 3.2,
                  py: 1.35,
                  borderRadius: "14px",
                  fontSize: "0.95rem",
                  fontWeight: 700,
                  minHeight: 50,
                  minWidth: { xs: "100%", sm: 230 },
                  boxShadow: "0 14px 30px rgba(0,0,0,0.18)",
                  "&:hover": {
                    backgroundColor: "#f3f8ff",
                  },
                }}
              >
                QUIERO MI PÁGINA WEB
              </Button>

              <Button
                component="a"
                href={waGeneral}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                sx={{
                  borderColor: "rgba(255,255,255,0.5)",
                  color: "#fff",
                  px: 3.2,
                  py: 1.35,
                  borderRadius: "14px",
                  fontSize: "0.95rem",
                  fontWeight: 700,
                  minHeight: 50,
                  minWidth: { xs: "100%", sm: 230 },
                  "&:hover": {
                    borderColor: "#fff",
                    backgroundColor: "rgba(255,255,255,0.08)",
                  },
                }}
              >
                HABLAR CON ASESOR
              </Button>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PromoWeb;